import { render, staticRenderFns } from "./AmnioticRearchInformation.vue?vue&type=template&id=22441b34&"
import script from "./AmnioticRearchInformation.vue?vue&type=script&lang=js&"
export * from "./AmnioticRearchInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports